export const parseJwt = (token) => {
  // Check if token exists and is valid
  if (!token || typeof token !== 'string' || token.trim() === '') {
    console.warn('⚠️ parseJwt: Invalid or missing token');
    return null;
  }
  
  try {
    var base64Url = token.split(".")[1];
    if (!base64Url) {
      console.warn('⚠️ parseJwt: Invalid JWT format');
      return null;
    }
    var base64 = base64Url.replace("-", "+").replace("_", "/");
    return JSON.parse(window.atob(base64));
  } catch (error) {
    console.error('❌ parseJwt error:', error);
    return null;
  }
};

// Safe wrapper to get token from localStorage and parse it
export const getTokenData = () => {
  const token = localStorage.getItem('Token');
  return parseJwt(token);
};

// Safe wrapper to get specific user data with fallback
export const getUserData = (defaultValue = {}) => {
  const tokenData = getTokenData();
  if (!tokenData || !tokenData.User) {
    console.warn('⚠️ getUserData: No valid user data in token');
    return defaultValue;
  }
  return tokenData.User;
};

// Safe wrapper to get SITECODE with fallback
export const getSitecode = (defaultValue = '') => {
  const userData = getUserData();
  return userData.SITECODE || defaultValue;
};
